import { Component } from "react";
import { InvestorPotStatus } from "../../types/investment/pot-summary";
import { getDirection } from "../component-utils";
import { formatCurrency } from "../simulator-page/simulator-utils";

interface Props {
  potStatus: InvestorPotStatus;
}

export class InvestorPotStatusDisplay extends Component<Props, {}> {
  public render() {
    const totalHoldings =
      this.props.potStatus && this.props.potStatus.totalHoldings;
    const totalDeposits =
      this.props.potStatus && this.props.potStatus.totalDeposits;
    const totalWithdrawals =
      this.props.potStatus && this.props.potStatus.totalWithdrawals;
    const totalApprovedInvestment =
      this.props.potStatus && this.props.potStatus.totalApprovedInvestment;
    const totalRequestedInvestment =
      this.props.potStatus && this.props.potStatus.totalRequestedInvestment;
    return (
      <div className="pot-summary-container">
        <div className="pot-summary-title">
          <div className="investor-page-title">Pot Summary</div>
        </div>
        {!!this.props.potStatus && (
          <div className="pot-summary-components">
            <div className="pot-summary pot-summary-item-a">
              <div className="pot-summary-holdings-title">Total Pot:</div>
              <div className="pot-summary-holdings">
                {formatCurrency(totalHoldings)}{" "}
                {getDirection(totalHoldings + totalWithdrawals, totalDeposits)}
              </div>
            </div>
            <div className="pot-summary pot-summary-item-b">
              <div className="pot-summary-holdings-title">Total Deposits:</div>
              <div className="pot-summary-holdings">
                {formatCurrency(totalDeposits)}
              </div>
            </div>
            <div className="pot-summary pot-summary-item-c">
              <div className="pot-summary-holdings-title">
                Total Withdrawals:
              </div>
              <div className="pot-summary-holdings">
                {formatCurrency(totalWithdrawals)}
              </div>
            </div>
            <div className="pot-summary pot-summary-item-d">
              <div className="pot-summary-holdings-title">
                Pending Clearance:
              </div>
              <div className="pot-summary-holdings">
                {formatCurrency(totalApprovedInvestment)}
              </div>
            </div>
            <div className="pot-summary pot-summary-item-e">
              <div className="pot-summary-holdings-title">
                Pending Approval:
              </div>
              <div className="pot-summary-holdings">
                {formatCurrency(
                  totalRequestedInvestment - totalApprovedInvestment
                )}
              </div>
            </div>
          </div>
        )}
        {!this.props.potStatus && <div className="italic">No Data...</div>}
      </div>
    );
  }
}
